import { render, staticRenderFns } from "./FalhaReconhecimento.vue?vue&type=template&id=4c8176bb&scoped=true&"
import script from "./FalhaReconhecimento.vue?vue&type=script&lang=js&"
export * from "./FalhaReconhecimento.vue?vue&type=script&lang=js&"
import style0 from "./FalhaReconhecimento.vue?vue&type=style&index=0&id=4c8176bb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8176bb",
  null
  
)

export default component.exports